import { render } from "./mvt-snapshot.vue?vue&type=template&id=56db4ad8"
import script from "./mvt-snapshot.js?vue&type=script&lang=js"
export * from "./mvt-snapshot.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__